import React, { useEffect, useState } from 'react'
import useSocketStore from '../../../store/socket'
import 'animate.css';
import ChatInput from './Input';
import Message from './Message';
import { getChatRoom, getChatRooms } from '../../../adapters/conversation';
import moment from 'moment/moment';
import EditModal from './EditModal';
import { Loading, LoadingData } from '../../Loading';

export default function Chat({ onClose, user, socket }) {

    const [showMessage, setShowMessage] = useState(false)
    const [showRoomDetails, setShowRoomDetails] = useState(false)
    const [chatRooms, setChatRooms] = useState([]);
    const [chatRecord, setChatRecord] = useState(null);
    const [isEditting, setIsEditting] = useState(false);
    const [ loading, setLoading ] = useState(false);

    const setNewMessage = useSocketStore((state) => state.setNewMessage)


    const getChats = async () => {
        setLoading(true)
        await getChatRooms().then((res) => {
            if(res.status === 200){
                setChatRooms(res.data);
            }
        });
        setLoading(false)
    };

    const chatDataHandler = (data) => {
        setChatRecord(data);
        setShowMessage(true);
    }

    const deletedMessageHandler = (data) => {
        if(chatRecord !== null && chatRecord._id === data._id){
            setChatRecord(data);
        }
    }

    const newMessageHandler = (data) => {
        if (chatRecord !== null && chatRecord._id === data.chat) {
            const getMessageIndex = chatRecord.messages.findIndex((ms) => ms._id === data._id)
            if (getMessageIndex){
                chatRecord.messages[getMessageIndex] = data;
                setChatRecord(chatRecord);
            }
            setNewMessage(true);
        }
    }

    const exitRoomHandler = (data) => {
        if (chatRecord !== null) {
            chatRecord.userLeft = true;
            chatRecord.members = chatRecord.members.filter((mem) => mem._id !== data);
            setChatRecord(chatRecord);
        }
    }

    useEffect(() => {
        getChats();
    }, [])

    useEffect(() => {
        socket.on('chatData', chatDataHandler)
        socket.on('deletedMessage', deletedMessageHandler)
        socket.on('sentMessage', newMessageHandler)
        socket.on('leftRoom', exitRoomHandler)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [socket])

    const closeMessage = async () => {
        if (showMessage && !showRoomDetails){
            setShowMessage(false);
            setChatRecord(null)
        }else if(showRoomDetails){
            setShowRoomDetails(false);
        }else{
            onClose()
        }
    }

    const showDetail = async () => {
        setShowRoomDetails(true)
    };

    const openMessage = async (chat) => {
        setLoading(true)
        await getChatRoom(chat._id).then((res) => {
            if(res.status === 200){
                chatDataHandler(res.data)
            }
            socket.emit('createOrJoinRoom', chat._id);
        })
        setLoading(false);
        // socket.emit('getChat', { chat: chat._id })
    }

    const leaveRoom = () => {
        socket.emit('leaveRoom', {chat: chatRecord._id});
    }

    const startEditingChat = () => {
        setIsEditting(true);
    }
    
    return (
        <>
            {isEditting && <EditModal onClose={() => setIsEditting(false)}  chat={chatRecord} setChatRecord={setChatRecord} user={user} />}
            <div className="fixed right-0 top-16 lg:w-96 w-full h-screen z-20 bg-white animate__animated animate__fadeInRightBig">
                
                <div className="pt-12 pb-18 h-full">
                    <div className="w-full py-1 z-30 bg-white flex justify-between px-4 absolute top-3 left-0 items-center">
                        {((showMessage || setShowRoomDetails) && chatRecord !== null) && <div onClick={showDetail} className="flex cursor-pointer hover:text-blue-900 items-center gap-1">
                            <img src={chatRecord.icon} alt="" className='rounded-full h-10 w-10 border-2 border-gray-600' />
                            <div>
                                <h4 className="text-sm font-semibold pb-0 mb-0 overflow-hidden text-ellipsis" title={chatRecord.title}>{chatRecord?.title}</h4>
                                <div className="text-xs h-3 overflow-hidden text-ellipsis">{chatRecord?.members.map((member) => `${member.name}, `)}</div>
                            </div>
                        </div>}
                        <button onClick={closeMessage} className="border-2 rounded-lg border-red-600 text-red-600 px-2 py-1 flex items-center text-xs hover:text-red-800 hover:border-red-800 font-semibold">
                            {showMessage ? (
                                <span>
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
                                    </svg>
                                </span>
                            ) : (
                                <span>
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </span>
                            )}
                            <span>{showMessage ? 'Back' : 'Close'}</span>
                        </button>
                    </div>
                    <div className="h-full overflow-scroll">
                        {/* CHat rooms */}
                        {(!showMessage && !showRoomDetails) && <div className="animate__animated animate__fadeIn">
                            <h4 className="mb-3 mt-3 px-4 font-semibold md:text-lg text-sm">
                                Chats
                            </h4>
                            <div className="h-8/12 flex flex-col gap-1 justify-end pb-4">
                                {Array.from(chatRooms).map((chR) => (<div onClick={() => openMessage(chR)} key={chR._id} className="py-4 border-b border-gray-500 hover:shadow-md px-4 hover:bg-gray-200 cursor-pointer">
                                    <div className="flex justify-between items-center">
                                        <div className="flex items-center gap-1 w-8/12">
                                            <img src={chR.icon} alt="" className='rounded-full h-10 w-10 border-2 border-gray-600' />
                                            <div>
                                                <h4 className="text-xs font-semibold pb-0 mb-0 overflow-hidden text-ellipsis" title={chR.title}>{chR.title}</h4>
                                                <span className="text-xs overflow-hidden text-ellipsis">
                                                    {chR.members.map((mem) => {
                                                        const memberIndex = chR.members.index;

                                                        if (memberIndex === (chR.members.length - 1)) {
                                                            return mem.split(' ')[0];
                                                        } else {
                                                            return `${mem.split(' ')[0]}, `;
                                                        }
                                                    })}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="text-xs w-4/12 text-right">
                                            <p className="text-right mb-1">{chR.lastMessage.sender.name}<br /> </p>
                                            <span className="bg-gray-800 px-2 rounded-full text-white">{moment(chR.lastMessage.createdAt).fromNow()}</span>
                                        </div>
                                    </div>
                                </div>))}

                                {chatRooms.length < 1 && <div className="h-full w-full flex flex-col justify-center items-center">
                                    <h4 className="text-lg font-semibold text-gray-800">No Conversations Yet</h4>
                                </div>}

                            </div>
                        </div>}

                        {showRoomDetails && <div className="animate__animated animate__fadeIn">
                            {chatRecord.creator._id === user._id && <div className="px-4 mt-8 w-full">
                                <button onClick={startEditingChat} className="w-full mx-auto rounded-md mb-2 hover:bg-blue-800 text-xs font-semibold font-fira border-2 border-blue-800 text-blue-800 hover:text-white py-2 px-4 text-center">
                                    Edit Room Info
                                </button>
                            </div>}
                            <div className="flex justify-between px-4 items-center">
                                <h4 className="mb-3 mt-3 font-semibold md:text-sm text-sm">
                                    Members
                                </h4>
                                <button onClick={leaveRoom} className="text-xs font-semibold hover:text-red-700 font-fira text-red-800">Leave Room</button>
                            </div>
                            <div className="px-6">
                                {Array.from(chatRecord.members).map((member) => (
                                    <div key={member.index} className="flex justify-between py-4 border-b border-gray-400 items-center">
                                        <div className="flex items-center gap-2 w-8/12">
                                            <img src={member.avatar} alt="" className='rounded-full h-8 w-8 border-2 border-gray-600' />
                                            <div>
                                                <h4 className="text-xs font-semibold pb-0 mb-0 overflow-hidden text-ellipsis">{member.name}</h4>
                                                <span className="text-xs overflow-hidden m-0 p-0 text-ellipsis">
                                                    <a href={`mailto:${member.email}`}>{member.email}</a>
                                                </span>
                                            </div>
                                        </div>
                                        {/* <div className="text-xs w-4/12 text-right">
                                    <p className="text-right mb-1">Torronto, Canada</p>
                                </div> */}
                                    </div>
                                ))}
                            </div>
                        </div>}
                        {/* chat input and Messages */}
                        {(showMessage && !showRoomDetails) && <>
                            {chatRecord !== null && <div className="h-8/12 px-4 pt-8 flex flex-col gap-1 mt-4 overflow-y-scroll overflow-x-hidden justify-end pb-4 animate__animated animate__fadeIn">
                                
                                {chatRecord.messages.map((chatMessage) => (<Message key={chatMessage._id} user={user} message={chatMessage} />))}
                            </div>}
                            <ChatInput user={user} socket={socket} chat={chatRecord} />
                        </>}
                    </div>
                </div>
                {/* <div className="absolute h-full w-full z-40 bg-white flex justify-center items-center flex-col">
                    <LoadingData message={"Loading..."} />
                </div> */}
            </div> 
        </>
    )
}
